import { BALANCE_TYPES } from './constants';

const parseBalances = (balances) => balances.reduce((acc, item) => {
    const key = Object.keys(BALANCE_TYPES).find((el) => item.balanceType === BALANCE_TYPES[el]);

    return {
        ...acc,
        [key]: item.balance?.amount
    };
}, {});

const parseBonusTemplates = (templates) =>
    templates.map((template) => ({
        code: template.code,
        name: template.name,
        bonusTranslations: template.bonusTranslations,
        marketingName: template.marketingName,
        description: template.description,
        bonusTcUrl: template.bonusTcUrl,
        gamingContext: template.gamingContext,
        playType: template.playType
    }));

export default ({ balances, bonusTemplates = [], conversion = {} }) => ({
    balances: parseBalances(balances),
    conversion,
    bonusTemplates: parseBonusTemplates(bonusTemplates)
});
